import { Box, Stack, Typography } from '@mui/material';
import { benefitItems } from './benefitItems';
import { BenefitItem } from './BenefitItem';
import { useTranslation } from 'hooks/useTranslation';

export const Benefits = () => {
    const { t, detect } = useTranslation();

    return (
        <Box sx={{ padding: { xs: '40px 0', lmd: '100px 0' }, backgroundColor: '#F6F8FC' }}>
            <Box sx={{ maxWidth: '1167px', margin: { xs: '0 20px', lmd: '0 auto' } }}>
                <Typography
                    variant="h2Bold"
                    sx={{
                        fontSize: { xs: detect.isIndonesianLanguage || detect.isFrenchLanguage ? '24px' : '28px', lmd: '34px' },
                        color: 'text.black',
                        marginBottom: '4px',
                    }}
                >
                    {t('Why LocateMate is the')}
                </Typography>
                <Typography
                    variant="h2Bold"
                    sx={{
                        fontSize: '38px',
                        background: 'linear-gradient(165deg, #0A2693 0%, #01CFFE 25%, #F2D3CD 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        mb: { xs: '32px', lmd: '44px' },
                        display: 'block',
                        width: 'fit-content',
                    }}
                >
                    {t('Right Choice')}
                </Typography>
                <Stack
                    sx={{
                        maxWidth: '836px',
                        margin: '0 auto',
                        flexDirection: 'row',
                        flexWrap: 'wrap',
                        gap: { xs: '56px', lmd: '44px' },
                    }}
                >
                    {benefitItems.map((item) => (
                        <BenefitItem
                            key={`benefit-${item.title}`}
                            title={t(item.title)}
                            text={t(item.text)}
                            imageUrl={item.icon}
                            sx={{
                                width: { xs: '100%', lmd: 'calc(50% - 22px)' },
                            }}
                        />
                    ))}
                </Stack>
            </Box>
        </Box>
    );
};
